module.exports = __webpack_public_path__ + "img/arrow_outward_white.6f99023f.svg";